// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3MaX8","itemTitle":"ClientEmergencyInfo_itemTitle__2B2uT","itemText":"ClientEmergencyInfo_itemText__Ak0Xs"};